import { MdDashboard, MdLogin,MdAbc, MdPeople, MdPerson, MdSettings, MdCalendarToday, MdTimer, MdFileCopy, MdCheck } from "react-icons/md"
// import {TbAbc} from 'react-icons/tb'
export const getIconsByType = (type) => {
    if(['service_add','service_delete','service_edit'].includes(type)){
      return <MdSettings/>;
    }else if(['PATIENT_add','PATIENT_delete','PATIENT_edit','CUSTOMER_add','CUSTOMER_delete','CUSTOMER_edit'].includes(type)){
      return <MdPerson/>;
    }else if(['register','login',].includes(type)){
      return <MdLogin/>;
    }else if(['register_staff','login_staff','edit_staff','delete_staff'].includes(type)){
      return <MdPeople/>;
    }else if(['FIELDS_add','FIELDS_edit','FIELDS_delete'].includes(type)){
      return <MdDashboard/>;
    }else if(['TEMPLATE_add','TEMPLATE_edit','TEMPLATE_delete'].includes(type)){
      return <strong className="text-xs">ABC</strong>;
    }else if(['APPOINTMENT_add','APPOINTMENT_delete','APPOINTMENT_edit'].includes(type)){
      return <MdCalendarToday/>;
    }else if(['TIMINGS_add','TIMINGS_delete','TIMINGS_edit'].includes(type)){
      return <MdTimer/>;
    }else if(['DOC_add','DOC_delete','DOC_edit'].includes(type)){
      return <MdFileCopy/>;
    }else {
      return <MdCheck/>;
    }
  }
  
  export const getColorsByType = (type) => {
    if(['service_add','PATIENT_add','CUSTOMER_add','register_staff','FIELDS_add','TEMPLATE_add','TIMINGS_add','APPOINTMENT_add','DOC_add'].includes(type)){
      return '#219104';
    }else if(['service_edit','edit_staff','PATIENT_edit','CUSTOMER_edit','FIELDS_edit','TEMPLATE_edit','TIMINGS_edit','APPOINTMENT_edit','DOC_edit'].includes(type)){
      return '#e38017';
    }else if(['PATIENT_delete','CUSTOMER_delete','service_delete','delete_staff','FIELDS_delete','TEMPLATE_delete','TIMINGS_delete','APPOINTMENT_delete','DOC_delete'].includes(type)){
      return '#ff0000';
    }else if(['register','login_staff','login'].includes(type)){
      return '#0B469D';
    }else {
      return '#72a9fb';
    }
  }